import type { NavChild } from '@/config/navigation';
import { useMenuLabels } from '@/features/menuLabels/hooks/useMenuLabels';

interface NavChildLabelProps {
  child: NavChild;
}

export function NavChildLabel({ child }: NavChildLabelProps) {
  const { labelOf } = useMenuLabels();

  return (
    <span className="flex-1 truncate">
      {labelOf(child.href)}
      {child.usedBy === undefined ? null : (
        <span className="ml-1 text-xs font-normal opacity-60">({child.usedBy})</span>
      )}
    </span>
  );
}
